export class RateBucket
{
	rateBucketId: number;
	createDate: Date;
	lastUpdate: Date;
	name: String
	description: String
}
